import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';

const imageHeight = grid.unitless * 5;

// eslint-disable-next-line rulesdir/no-styled-export
export const Image = styled.img`
    height: ${imageHeight}px;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.div`
    height: ${imageHeight}px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${token('space.100', '8px')};
    font-weight: 600;
`;
